import React from 'react';
import { Col, DatePicker, Radio, Row, Select, Checkbox } from 'antd';
import moment from 'moment';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

export default class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16} align="middle">
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idMoneda ? { key: this.props.filter.idMoneda } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Moneda" />}
                            onChange={(option) => this.props.onChange("idMoneda", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.monedas.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idVendedor ? { key: this.props.filter.idVendedor } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Vendedor" />}
                            onChange={(option) => this.props.onChange("idVendedor", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.vendedores.map(item => (
                                <Select.Option key={item.id}>{item.razonSocialEntidad}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select showSearch labelInValue
                            value={this.props.filter.idProyecto ? { key: this.props.filter.idProyecto } : undefined}
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.proyectos.map(item => (
                                <Select.Option key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={5}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                            <Radio.Group
                                value={this.props.filter.tipoReporte}
                                onChange={(e) => this.props.onChange("tipoReporte", e.target.value)}
                            >
                                <Radio value={1}>Ranking</Radio>
                                <Radio value={2}>Resumen</Radio>
                                <Radio value={3}>Detallado</Radio>
                            </Radio.Group>
                        </div>
                    </Col>

                    <Col className="gutter-row" sm={24} md={24} lg={24}>
                        <div style={{ height: '32px', display: 'flex', alignItems: 'left', justifyContent: 'left' }} >
                            <Radio.Group
                                value={this.props.filter.tipoComprobante}
                                onChange={(e) => this.props.onChange("tipoComprobante", e.target.value)}
                            >
                                <Radio value={1}>Solo comprobantes tributarios</Radio>
                                <Radio value={2}>Solo notas de ventas</Radio>
                                <Radio value={0}>Todos los comprobantes</Radio>
                            </Radio.Group>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}